function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m15 57h6v2h-6z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m60.969 30h.031v-4c0-2.757-2.243-5-5-5h-.062c.026-.333.062-.663.062-1 0-7.168-5.832-13-13-13-3.018 0-5.791 1.043-8 2.774v-3.774c0-2.757-2.243-5-5-5h-24c-2.757 0-5 2.243-5 5v52c0 2.757 2.243 5 5 5h24c2.757 0 5-2.243 5-5v-1h23c2.757 0 5-2.243 5-5v-18c0-1.641-.806-3.088-2.031-4zm-4.969-7c1.654 0 3 1.346 3 3v3.101c-.323-.066-.658-.101-1-.101h-5.647c1.615-1.676 2.751-3.741 3.286-6zm-13-14c6.065 0 11 4.935 11 11 0 3.599-1.76 6.936-4.705 9h-5.295v-2.142c1.72-.447 3-2 3-3.858 0-2.206-1.794-4-4-4-1.103 0-2-.897-2-2s.897-2 2-2 2 .897 2 2h2c0-1.858-1.28-3.411-3-3.858v-2.142h-2v2.142c-1.72.447-3 2-3 3.858 0 2.206 1.794 4 4 4 1.103 0 2 .897 2 2s-.897 2-2 2-2-.897-2-2h-2c0 1.858 1.28 3.411 3 3.858v2.142h-5.295c-2.945-2.064-4.705-5.401-4.705-9 0-6.065 4.935-11 11-11zm-19.899 44h-20.101v-44h30v2.705c-1.872 2.253-3 5.144-3 8.295 0 .337.036.667.062 1h-2.062c-2.757 0-5 2.243-5 5v26c0 .342.035.677.101 1zm4.899-30h2.361c.163.687.385 1.353.655 2h-3.016v2h4v-.116c.474.757 1.021 1.467 1.647 2.116h-5.647c-1.654 0-3-1.346-3-3s1.346-3 3-3zm-22-20h24c1.654 0 3 1.346 3 3v1h-30v-1c0-1.654 1.346-3 3-3zm27 55c0 1.654-1.346 3-3 3h-24c-1.654 0-3-1.346-3-3v-3h21v-.031c.912 1.225 2.359 2.031 4 2.031h5zm25-3h-30c-1.654 0-3-1.346-3-3v-22.002c.836.628 1.875 1.002 3 1.002h30c1.654 0 3 1.346 3 3v3h-12c-3.309 0-6 2.691-6 6s2.691 6 6 6h12v3c0 1.654-1.346 3-3 3zm3-16v8h-12c-2.206 0-4-1.794-4-4s1.794-4 4-4z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m47 42h2v2h-2z"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m50 19h2v2h-2z"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "m34 19h2v2h-2z"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "m59 11h2v2h-2z"
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  d: "m59 15h2v2h-2z"
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  d: "m61 13h2v2h-2z"
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  d: "m57 13h2v2h-2z"
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  d: "m25 13h2v2h-2z"
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  d: "m25 17h2v2h-2z"
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  d: "m27 15h2v2h-2z"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "m23 15h2v2h-2z"
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  d: "m51 1h2v2h-2z"
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  d: "m51 5h2v2h-2z"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "m53 3h2v2h-2z"
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  d: "m49 3h2v2h-2z"
});

function SvgFintech(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: 140,
    viewBox: "0 0 64 64",
    width: 140,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFintech);
export default __webpack_public_path__ + "static/media/fintech.67e16d72.svg";
export { ForwardRef as ReactComponent };